import React from 'react';
import styles from './StrategySettings.module.css';
import StrategyRuleSettings from '../components/StrategyRuleSettings';

function StrategySettings(){    
         
    return (        
        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>Strategy Settings</h1>
            </header>
            <main>
                <section className={styles.content}>                    
                    <StrategyRuleSettings title = 'Buy' />
                    <StrategyRuleSettings title = 'Sell' />
                </section>
            </main>            
        </div>
    );
}

export default StrategySettings;






